import { useMeQuery } from '@/features/me';
import { useWorkspace } from '@/features/workspace';
import { usePlanLimits } from '@/hooks/planLimits';

export function useEmailBanner() {
  const { data: me } = useMeQuery();
  const workspace = useWorkspace();
  const canAccessFeature = usePlanLimits();
  const canAccessGmail = canAccessFeature('gmail_integration');

  const showBanner =
    canAccessGmail && workspace?.gmailEnabled && me?.gmailStatus !== 'enabled';

  return { showBanner };
}
